export enum UserAbilitationTypes {
    ABILITATED = 'ABILITATED',
    BANNED = 'BANNED'
}